<template>
	<div>
		<div class="row">
			<div class="col-6 col-lg-3">
				<div class="block block-link-shadow text-center">
					<div class="block-content block-content-full">
						<div class="font-size-h2 text-primary">{{ data.ordersToday }}</div>
					</div>
					<div class="block-content py-2 bg-body-light">
						<p class="font-w600 font-size-sm text-muted mb-0">
							Orders Today
						</p>
					</div>
				</div>
			</div>
			<div class="col-6 col-lg-3">
				<div class="block block-link-shadow text-center">
					<div class="block-content block-content-full">
						<div class="font-size-h2">{{ data.ordersYesterday }}</div>
					</div>
					<div class="block-content py-2 bg-body-light">
						<p class="font-w600 font-size-sm text-muted mb-0">
							Orders Yesterday
						</p>
					</div>
				</div>
			</div>
			<div class="col-6 col-lg-3">
				<div class="block block-link-shadow text-center">
					<div class="block-content block-content-full">
						<div class="font-size-h2 text-dark">{{ data.ordersThisMonth }}</div>
					</div>
					<div class="block-content py-2 bg-body-light">
						<p class="font-w600 font-size-sm text-muted mb-0">
							Orders in {{data.month}}
						</p>
					</div>
				</div>
			</div>
			<div class="col-6 col-lg-3">
				<div class="block block-link-shadow text-center">
					<div class="block-content block-content-full">
						<div class="font-size-h2 text-dark">{{ data.ordersThisYear }}</div>
					</div>
					<div class="block-content py-2 bg-body-light">
						<p class="font-w600 font-size-sm text-muted mb-0">
							Orders in {{data.year}}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xl-12">
				<div class="block">
					<div class="block-header block-header-default">
						<h3 class="block-title">Latest Orders</h3>
					</div>
					<div class="block-content">
						<table class="table table-borderless table-striped table-vcenter font-size-sm">
							<tbody>
							<tr v-for="order in data.orders" :key="order.id">
								<td class="font-w600 text-center">
									<a :href="'/admin/'+order.partner_id+'/order/'+order.id">{{ order.id }}</a>
								</td>
								<td class="d-none d-sm-table-cell">
									{{ order.customerName }}
								</td>
								<td class="d-none d-sm-table-cell">
									<a :href="'/admin/'+order.partner_id+'/offer/'+order.offer_id">{{ order.offerName }}</a>
								</td>
								<td>
									{{ moment.utc(order.purchased_at).tz(order.partnerTimezone).format('YYYY-MM-DD hh:mm:ss a') }}
								</td>
								<td class="font-w600">{{ order.price_paid }}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Object,
				default: {}
			}
		},
		components: {
		},
		methods: {

		},
		data() {
			return {
			};
		},
		beforeMount() {

		},
		mounted() {
			
		}
	};
</script>